export const EXPORT_ORDER = [
  { key: 'id', label: 'ID' },
  { key: 'version', label: 'Versão' },
  { key: 'type', label: 'Tipo' },
  { key: 'status', label: 'status' },
  { key: 'title', label: 'Título' },
  { key: 'createdAt', label: 'Criado em' },
  { key: 'publishedAt', label: 'Publicado em' },
];

export const narrowPdfWidths = {
  version: 55,
  type: 70,
  status: 80,
  id: 150,
  title: '*',
  createdAt: 115,
  updatedAt: 115,
  publishedAt: 115,
};

export const XLSX_COL_WIDTHS = {
  ID: 28,
  Versão: 8,
  Tipo: 10,
  status: 12,
  Título: 50,
  'Criado em': 20,
  'Publicado em': 20,
};
